import ProductPage from "../../components/ProductPage";
import { iepfData } from "../../data/productsData";
export default function IEPF() { return <ProductPage data={iepfData} />; }